import React from 'react';
import { SCHEDULER_URL } from '../../constants';

function Nav() {
  return (
    <nav className="sticky top-0 z-50 bg-cream/[0.82] backdrop-blur-[10px] border-b border-navy-deep/[0.06]">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 md:px-8 py-[18px] flex items-center justify-between gap-3 md:gap-4">
        <div className="flex items-center gap-2.5 font-display font-bold text-[1.15rem] text-navy-deep">
          <span className="w-2.5 h-2.5 rounded-full bg-sky shadow-[0_0_0_4px_rgba(115,199,227,0.25)] flex-none" />
          <span className="whitespace-nowrap">
            <span className="sm:hidden">Goldilocks</span>
            <span className="hidden sm:inline">Goldilocks Smart Solutions</span>
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8 text-[0.94rem] font-medium text-navy">
          <a href="#predict" className="hover:text-navy-deep transition-colors outline-none focus-visible:ring-2 focus-visible:ring-sky rounded-sm">
            Care Check
          </a>
          <a href="#gallery" className="hover:text-navy-deep transition-colors outline-none focus-visible:ring-2 focus-visible:ring-sky rounded-sm">
            Goldie V2
          </a>
          <a href="#pilots" className="hover:text-navy-deep transition-colors outline-none focus-visible:ring-2 focus-visible:ring-sky rounded-sm">
            Pilots
          </a>
        </div>

        <a
          href={SCHEDULER_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-cream shadow-nu-btn rounded-full px-3 py-2.5 md:px-[22px] md:py-3 font-semibold text-[0.82rem] md:text-[0.92rem] text-navy-deep whitespace-nowrap transition-transform hover:-translate-y-0.5 outline-none focus-visible:ring-2 focus-visible:ring-sky focus-visible:ring-offset-2 focus-visible:ring-offset-cream"
        >
          Request a Demo
        </a>
      </div>
    </nav>
  );
}

export default Nav;
